import { RootState } from '../../store';

export const editAddressData = (state: RootState) => state.editAddreses;
